import CircularProgress, {
  CircularProgressProps,
} from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { styles } from "./styles";
import { APP_COLOR, FONT_FAMILY } from "../../theme";

export const CustomCircularProgress = (
  props: CircularProgressProps & { value?: number; customcolor?: string }
): JSX.Element => {
  return (
    <Box
      sx={{
        position: "relative",
        display: "inline-flex",
        color: props.customcolor ? props.customcolor : APP_COLOR,
      }}
    >
      <CircularProgress
        color="inherit"
        size={80}
        variant={props.value ? "determinate" : "indeterminate"}
        {...props}
      />
      <Box sx={styles.progressContainer}>
        {props.value && (
          <Typography
            variant="body2"
            component="div"
            color="text.secondary"
            sx={{ fontFamily: FONT_FAMILY }}
          >{`${Math.round(props.value)}%`}</Typography>
        )}
      </Box>
    </Box>
  );
};
